import { useRequiredContext } from "@redotech/react-util/context";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import BarChart10FilledIcon from "@redotech/redo-web/icon-old/bar-chart-10-filled.svg";
import BarChart10Icon from "@redotech/redo-web/icon-old/bar-chart-10.svg";
import { memo } from "react";
import { useMatch } from "react-router-dom";

export const AnalyticsItems = memo(function AnalyticsItems() {
  const routes = useRequiredContext(MerchantRoutesContext);

  const conversionAnalyticsRoot = routes.conversionAnalyticsHref;
  const anyChildSelected = useMatch(`${conversionAnalyticsRoot}/*`);

  return (
    <RedoSecondaryNavItem
      action={{
        type: "link",
        href: routes.getConversionSubRoute("analytics/checkout"),
      }}
      anyChildSelected={!!anyChildSelected}
      FilledIcon={BarChart10FilledIcon}
      friendlyName="Analytics"
      id="analytics"
      UnfilledIcon={BarChart10Icon}
    >
      <RedoSecondaryNavItem
        action={{
          type: "link",
          href: routes.getConversionSubRoute("analytics/checkout"),
        }}
        friendlyName="Checkout"
        id="checkout-analytics"
      />
      <RedoSecondaryNavItem
        action={{
          type: "link",
          href: routes.getConversionSubRoute("analytics/post-purchase"),
        }}
        friendlyName="Post-purchase"
        id="post-purchase-analytics"
      />
    </RedoSecondaryNavItem>
  );
});
